import { render, staticRenderFns } from "./SizeRating.vue?vue&type=template&id=d76bea06"
import script from "./SizeRating.vue?vue&type=script&lang=js"
export * from "./SizeRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports